/** Namespace `configSync` — PLAT-2026-111: trạng thái hub ĐẨY cấu hình sang app (bản số, nhận lúc, lỗi, « Đẩy lại »). */
export const configSync = {
  title: "Đồng bộ cấu hình sang app",
  intro:
    "Hub chỉ là nơi sửa. Mỗi lần lưu, hub đẩy bản chụp cấu hình sang app; app lưu trong CSDL của chính nó và chạy từ đó — hub sập không ảnh hưởng app.",
  loadFailed: "Không đọc được trạng thái đồng bộ.",
  pushFailed: "Không đẩy được.",
  version: "Bản số",
  versionValue: "v{current} (app giữ v{acked})",
  versionNone: "chưa có",
  receivedAt: "App nhận lúc",
  lastPushAt: "Đẩy lần cuối",
  never: "chưa bao giờ",
  lastError: "Lỗi gần nhất",
  push: "Đẩy lại",
  pushing: "Đang đẩy…",
  "state.not_configured": "Chưa nối",
  "state.never": "Chưa đẩy",
  "state.in_sync": "Đã đồng bộ",
  "state.pending": "Chờ app nhận",
  "state.failed": "Đẩy hỏng",
  notConfiguredHint: "Hub thiếu URL / secret của app này (`HQ_<APP>_API_URL`, `HQ_<APP>_SERVICE_SECRET`).",
  savedSyncFailed: "Đã lưu, nhưng đẩy sang {apps} hỏng — xem « Đồng bộ cấu hình sang app ».",
} as const;
